import React from "react";
import { FaStar, FaShoppingCart } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useCart } from "../../hooks/CartContext";

const Product = ({
  products = [],
  title = "Our Products",
  showFilterButton = true,
}) => {
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  const isFilterPage = location.pathname === "/filter";

  return (
    <div className="w-full">
      {/* Header */}
      <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h1 className="text-xl font-bold text-gray-900 sm:text-2xl">
          {title}
        </h1>

        {showFilterButton && !isFilterPage && (
          <Link
            to="/filter"
            className="inline-flex items-center justify-center rounded-xl bg-red px-5 py-2.5 font-semibold text-white transition hover:opacity-90"
          >
            Filter
          </Link>
        )}
      </div>

      {/* Grid */}
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 sm:gap-5 md:grid-cols-3 lg:grid-cols-4">
        {products.map((p) => {
          const soldOut = Number(p?.quantity || 0) < 1;
          const hasDiscount =
            Number(p?.price || 0) > Number(p?.finalPrice || 0);

          return (
            <div
              key={p?._id}
              onClick={() => navigate(`/product/${p?._id}`)}
              className="group overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm transition hover:shadow-md cursor-pointer"
            >
              {/* Image */}
              <div className="relative">
                <img
                  src={p?.images?.[0] || "/placeholder.png"}
                  alt={p?.name || "Product"}
                  className="h-40 w-full bg-gray-100 object-cover sm:h-48"
                />

                <div className="absolute right-3 top-3 flex flex-wrap gap-2">
                  {p?.condition && (
                    <span className="rounded-full bg-white/95 px-2.5 py-1 text-[11px] font-semibold text-gray-700 shadow-sm">
                      {p.condition}
                    </span>
                  )}

                  {soldOut ? (
                    <span className="rounded-full bg-gray-900/90 px-2.5 py-1 text-[11px] font-semibold text-white shadow-sm">
                      Sold Out
                    </span>
                  ) : (
                    <span className="rounded-full bg-red px-2.5 py-1 text-[11px] font-semibold text-white shadow-sm">
                      In Stock
                    </span>
                  )}
                </div>
              </div>

              {/* Content */}
              <div className="p-4">
                {/* Name */}
                <div className="min-w-0">
                  <h2 className="truncate text-sm font-semibold text-gray-900 sm:text-base">
                    {p?.name}
                  </h2>

                  <div className="mt-1 flex flex-wrap gap-2">
                    {p?.category && (
                      <span className="text-xs text-gray-500">
                        {p.category}
                      </span>
                    )}
                    {p?.platform && (
                      <span className="text-xs text-gray-500">
                        • {p.platform}
                      </span>
                    )}
                  </div>
                </div>

                {/* Brand */}
                {p?.brand && (
                  <p className="mt-2 truncate text-xs font-medium text-gray-600">
                    {p.brand}
                  </p>
                )}

                {/* Rating + Stock */}
                <div className="mt-3 flex items-center justify-between text-sm">
                  <span className="flex items-center gap-1 font-bold text-yellow-500">
                    <FaStar />
                    {Number(p?.averageRating || 0).toFixed(1)}
                  </span>

                  {/* <span
                    className={`text-xs font-semibold ${
                      soldOut ? "text-gray-500" : "text-red"
                    }`}
                  >
                    {soldOut
                      ? "Sold out"
                      : `${p?.quantity} unit${Number(p?.quantity) !== 1 ? "s" : ""} left`}
                  </span> */}
                </div>

                {/* Price */}
                <div className="mt-3 flex items-end justify-between gap-2">
                  <p className="text-base font-bold text-gray-900 sm:text-lg">
                    ₦{Number(p?.finalPrice || 0).toLocaleString()}
                  </p>
                      { p?.discount > 0 && <>  {hasDiscount && (
                    <p className="text-sm font-semibold text-gray-400 line-through">
                      ₦{Number(p?.price || 0).toLocaleString()}
                    </p>
                  )}</>}
                
                </div>

                {/* CTA */}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    if (soldOut) return;
                    addToCart(p, 1);
                  }}
                  disabled={soldOut}
                  className={`mt-4 flex w-full items-center justify-center gap-2 rounded-xl py-2.5 font-semibold transition ${
                    soldOut
                      ? "cursor-not-allowed bg-gray-200 text-gray-600"
                      : "bg-red text-white hover:opacity-90"
                  }`}
                >
                  <FaShoppingCart />
                  {soldOut ? "Sold Out" : "Add to Cart"}
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {/* Empty state */}
      {products.length === 0 && (
        <div className="rounded-2xl border border-gray-100 bg-white p-8 text-center shadow-sm">
          <p className="font-semibold text-gray-900">No products found</p>
          <p className="mt-1 text-sm text-gray-500">
            Try another filter or search.
          </p>
        </div>
      )}
    </div>
  );
};

export default Product;